import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaGavel } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const auctionAccess = permission.find((o) => o.slug === "auction_event");
const bidsAccess = permission.find((o) => o.slug === "bid_list");



const AuctionSubMenu = () => {

    const hasReadPermissionForAuctions = auctionAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForBids = bidsAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForAuctions &&
        !hasReadPermissionForBids
    ) {
        return null
    }

    return (
        <>
            <Tooltip title='Auctions' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaGavel />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    {hasReadPermissionForAuctions &&
                        <>
                            <TextLink
                                to="/auction-events"
                                onClick={handleClose}
                            >
                                Auction Events
                            </TextLink>
                            <TextLink
                                to="/auctions"
                                onClick={handleClose}
                            >
                                Auctions
                            </TextLink>
                            <TextLink
                                to="/auction-deposit-history"
                                onClick={handleClose}
                            >
                                Auction Deposit History
                            </TextLink>
                            <TextLink
                                to="/on-hold-deposits"
                                onClick={handleClose}
                            >
                                On Hold Deposits
                            </TextLink>
                            <TextLink
                                to="/cancel-auction-reservation-request"
                                onClick={handleClose}
                            >
                                Cancel Auction Reservation
                            </TextLink>
                        </>
                    }
                    {hasReadPermissionForBids &&
                        <TextLink to="/bid-list" onClick={handleClose}>
                            Bids
                        </TextLink>
                    }
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default AuctionSubMenu